"use client";

import PowerBIDashboardIndicadores from "../PowerBI/PowerBIDashboardIndicadores";

export default function IframeTabs({ tabs = [] }: any) {
  return (
    <div className="relative w-full">
      <div className="w-full py-[32px]">
        <PowerBIDashboardIndicadores
          tabs={tabs}
          initialMapType="Continental"
        />
      </div>
    </div>
  );
}